import { media } from "src/styles/mixins";
import styled from "styled-components";

export const SummaryElementWrapper = styled.div`
  min-height: 200px;
  padding: 18px 18px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  h4 {
    font-size: ${({ theme }) => theme.fonts.sizes.xxs};
    font-weight: ${({ theme }) => theme.fonts.weights.normal};
    line-height: ${({ theme }) => theme.fonts.lineHeights.xs};
  }

  h3 {
    font-size: ${({ theme }) => theme.fonts.sizes.s};
    font-weight: ${({ theme }) => theme.fonts.weights.bolder};
    line-height: ${({ theme }) => theme.fonts.lineHeights.xs};
  }

  ${media.up("LAPTOP")`
    padding: 18px 36px;
    flex-direction: row;
    min-height: 100px;
  `}
`;

export const LowerRowWrapper = styled.div`
  flex: 8;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
`;

export const Separator = styled.div`
  background-color: ${({ theme }) => theme.colors.accent};
  align-self: center;
  width: 85%;
  min-height: 1.5px;
  border-radius: 8px;

  &:last-child {
    display: none;
  }
`;

export const InformationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  h3,
  h4 {
    text-align: center;
  }
`;

export const LargeInformationWrapper = styled.div`
  flex: 4;
  h3,
  h4 {
    text-align: center;
  }
`;
